var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChinaTelecom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#02489D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.188 3.956s-.418-.463-.97-.463c0 0-1.208 0-2.029 2.611 0 0-.701 2.283-.701 5.67 0 0 0 3.193.657 5.445 0 0 .656 2.283 1.61 2.283 0 0 .672 0 1.24-1.253 0 0 .566-1.253.805-3.297l1.79-.448s-.462 3.804-1.895 6.266c0 0-1.477 2.477-3.342 2.477 0 0-2.238 0-3.82-3.357 0 0-1.58-3.357-1.58-8.116 0 0 0-4.76 1.58-8.146 0 0 1.582-3.372 3.82-3.372 0 0 2.238 0 3.835 3.431l-1 .269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.484 8.536s-3.088 2.551-8.012 3.79c0 0-4.938 1.223-8.862.417 0 0-3.924-.835-4.506-3.237 0 0-.492-2 1.671-4.208 0 0 2.134-2.193 5.968-3.655l.254.985S5.759 3.583 4.52 4.79c0 0-1.268 1.268-.984 2.357 0 0 .373 1.388 2.999 1.806 0 0 2.61.402 5.997-.433 0 0 3.357-.836 5.506-2.432 0 0 2.118-1.611 1.76-3.014 0 0-.298-1.208-2.447-1.73L17.023.062s2.79.104 4.64 1.029c0 0 1.895.925 2.283 2.492 0 0 .612 2.387-2.462 4.953"
  }))));
}

export default SvgChinaTelecom;